import { FC } from 'react';

import FullPageLayout from 'src/app/layouts/FullPageLayout';
import ContainerForXSL from 'src/components/CodeInjector/ContainerForXSL';

const LegacyPage: FC = () => {
    return (
        <FullPageLayout>
            <ContainerForXSL place="legacy-page-layout-xsl" />
        </FullPageLayout>
    );
};

export default LegacyPage;
